export default __webpack_public_path__ + "static/media/bccLogo.3a8641a2.png";